const StopColors = {
    white: '#ffffff',
    lightBlack: '#262626',
    black: '#000000',
   };
   
   export { StopColors as default };
   